import styled, { css } from 'styled-components'

const Container = styled.div`
  border-top: 2px solid var(--orange);
  margin: 20px 0;
  padding: 20px 0;
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;

  ${props =>
    props.hasBackButton &&
    css`
      justify-content: flex-end;
    `}
`

export { Container, Buttons }
